// Adapts the backend's effective design (GET /api/projects/{id}/dbdesign -> .design) to the
// inputs of the ported buildErDiagram(schemaTables, primaryKeys, foreignKeys).
//
// Backend shape: tables[{name, fields[{name,type}]}], primary_keys[{table,column}],
// foreign_keys[{table,field,ref_table,ref_field}], entities[{name, key{name,type}, members[{table,field}]}].
// Shared entities become their own (hub) tables, as in the built database.
import { buildErDiagram } from "./erDiagram";

export function designToDiagram(design) {
  if (!design) return buildErDiagram({}, [], []);
  const tables = {};
  (design.tables || []).forEach(t => {
    tables[t.name] = (t.fields || []).map(f => ({ name: f.name, type: f.type }));
  });
  const entities = design.entities || [];
  entities.forEach(e => { tables[e.name] = [{ name: e.key.name, type: e.key.type }]; });
  const primaryKeys = [
    ...(design.primary_keys || []),
    ...entities.map(e => ({ table: e.name, column: e.key.name })),
  ];
  const foreignKeys = [
    ...(design.foreign_keys || []).map(f => ({
      table: f.table, column: f.field, ref_table: f.ref_table, ref_column: f.ref_field,
    })),
    ...entities.flatMap(e => e.members.map(m => ({
      table: m.table, column: m.field, ref_table: e.name, ref_column: e.key.name,
    }))),
  ];
  return buildErDiagram(tables, primaryKeys, foreignKeys);
}
